import type { SVGProps } from "react";
const SenecPictogramServer = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M10 13C10 12.4477 10.4477 12 11 12H22C22.5523 12 23 12.4477 23 13C23 13.5523 22.5523 14 22 14H11C10.4477 14 10 13.5523 10 13Z"
            fill="currentColor"
        />
        <path
            d="M35.5 14.5C36.3284 14.5 37 13.8284 37 13C37 12.1716 36.3284 11.5 35.5 11.5C34.6716 11.5 34 12.1716 34 13C34 13.8284 34.6716 14.5 35.5 14.5Z"
            fill="currentColor"
        />
        <path
            d="M10 23C10 22.4477 10.4477 22 11 22H22C22.5523 22 23 22.4477 23 23C23 23.5523 22.5523 24 22 24H11C10.4477 24 10 23.5523 10 23Z"
            fill="currentColor"
        />
        <path
            d="M37 23C37 23.8284 36.3284 24.5 35.5 24.5C34.6716 24.5 34 23.8284 34 23C34 22.1716 34.6716 21.5 35.5 21.5C36.3284 21.5 37 22.1716 37 23Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 7C6.79086 7 5 8.79086 5 11V28C5 28.5523 5.44772 29 6 29H41V35C41 36.1046 40.1046 37 39 37H9C7.89543 37 7 36.1046 7 35V33C7 32.4477 6.55228 32 6 32C5.44772 32 5 32.4477 5 33V35C5 37.2091 6.79086 39 9 39H39C41.2091 39 43 37.2091 43 35V11C43 8.79086 41.2091 7 39 7H9ZM41 11C41 9.89543 40.1046 9 39 9H9C7.89543 9 7 9.89543 7 11V17H41V11ZM7 19H41V27H7V19Z"
            fill="currentColor"
        />
        <path
            d="M11 32C10.4477 32 10 32.4477 10 33C10 33.5523 10.4477 34 11 34H22C22.5523 34 23 33.5523 23 33C23 32.4477 22.5523 32 22 32H11Z"
            fill="currentColor"
        />
        <path
            d="M35.5 34.5C36.3284 34.5 37 33.8284 37 33C37 32.1716 36.3284 31.5 35.5 31.5C34.6716 31.5 34 32.1716 34 33C34 33.8284 34.6716 34.5 35.5 34.5Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramServer;
